import MobilePay from './views/mobilePay.c';
export default MobilePay;
